import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type CompanyAvatarProps = {
  className?: string;
  companyName: null | string;
  /** Signed by the server; absent for a company with no logo, and after a signing failure. */
  logoUrl?: null | string;
};

/** The uploaded logo when there is one, otherwise the first letter of the name (CT-9 §7). */
export const CompanyAvatar: FC<CompanyAvatarProps> = ({ className, companyName, logoUrl }) => {
  const shell = twMerge(
    'flex size-12 shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#172335] text-lg font-[600] text-white',
    className,
  );

  if (logoUrl) {
    return (
      <div className={shell}>
        <img alt={companyName ?? ''} className="size-full object-cover" src={logoUrl} />
      </div>
    );
  }

  return <div className={shell}>{(companyName?.trim()[0] ?? '?').toUpperCase()}</div>;
};
